import { Typography, type TypographyProps } from '../typography/Typography';
import { IfNodeRenders } from '../util/IfNodeRenders';

export const EmptyMessageTitle = ({ children, ...props }: TypographyProps<'div'>) => (
  <IfNodeRenders node={children}>
    <Typography color='text.primary' textAlign='center' variant='h6' {...props}>
      {children}
    </Typography>
  </IfNodeRenders>
);
